export { default as awardImg } from './award.svg';
export { default as awardMobileImg } from './award-mobile.svg';
export { default as chargerImg } from './charger.svg';
export { default as chargerMobileImg } from './charger-mobile.svg';
export { default as claimsImg } from './claims.svg';
export { default as claimsMobileImg } from './claims-mobile.svg';
export { default as crashImg } from './crash.svg';
export { default as crashMobileImg } from './crash-mobile.svg';
export { default as emergencyImg } from './emergency.svg';
export { default as emergencyMobileImg } from './emergency-mobile.svg';
export { default as repairImg } from './repair.svg';
export { default as repairMobileImg } from './repair-mobile.svg';
